<template>
  <div class="hp-base-panel-wrp">
    <div class="desc-panel hp-base-panel">
      <template v-if="qualification">
        <div class="hp-title">
          <div>
            <em class="left">专业资质</em>
          </div>
        </div>
        <div class="normal-text" v-html="qualification"></div>
      </template>
      <template v-if="trainings.length">
        <div class="hp-title training-title">
          <em class="left exp" @click="onClickExp"
            >专业受训
            <div class="icon-desc"></div
          ></em>
        </div>
        <trainItem
          v-if="commonTrain.length"
          :trainings="commonTrain"
          :title="'培训经历'"
          @toggle="handleFold"
        />
        <trainItem
          v-if="theoryTranin.length"
          :trainings="theoryTranin"
          :title="'伦理培训'"
          @toggle="handleFold"
        />
        <trainItem
          v-if="beLeadInfo.length"
          :trainings="beLeadInfo"
          :title="'专业督导'"
          @toggle="handleFold"
        />
      </template>

      <div class="bottom-tip">
        倾听师本人承诺以上资料全部属实，接受公众监督，并为此承担相应法律责任。
      </div>
    </div>
    <qingsuModel :show.sync="showQingsuModel" :msg="expMsg" />
  </div>
</template>

<script>
import qingsuModel from './qingsuModel.vue'
import trainItem from './trainItem.vue'

export default {
  components: {
    qingsuModel,
    trainItem
  },
  data() {
    return {
      tagDetail: null,
      showQingsuModel: false
    }
  },
  computed: {
    qingsuInfo() {
      return this.$store.state.homepage.qingsuService.info || {}
    },
    qualification() {
      return this.qingsuInfo.qualification || ''
    },
    trainings() {
      return this.qingsuInfo.training || []
    },
    commonTrain() {
      return this.trainings.filter(item => +item.training_type === 1)
    },
    theoryTranin() {
      return this.trainings.filter(item => +item.training_type === 2)
    },
    beLeadInfo() {
      return this.qingsuInfo.be_lead_info || []
    },
    expMsg() {
      return {
        modelTitle: '专业受训',
        description:
          '专业受训指倾听师在心理方向接受培训的背景，主要包含了学历、课程培训、专项培训、个人体验、督导等内容，是行业内评估倾听师胜任力的关键指标。<br/><br/>比如培训学习是否是接受同一流派持续的学习；是否有稳定的个人体验；是否持续接受督导的学习；是否有伦理、危机等专项培训。'
      }
    }
  },
  methods: {
    handleFold(folded) {
      if (!folded) {
        this.$trackEvent('newprofilepages_training_all', {})
      }
    },
    onClickExp() {
      this.$trackEvent('newprofilepages_listener_traininginstructions')
      this.showQingsuModel = true
    }
  }
}
</script>

<style lang="scss" scoped>
.hp-title {
  padding-bottom: 26px !important;
  padding-top: 50px;
  align-items: center;
  &:nth-of-type(1) {
    padding-top: 0;
  }
  .exp {
    display: flex;
    align-items: center;
  }
  .icon-desc {
    margin-left: 10px;
    width: 25px;
    height: 25px;
    background: url('../../../../images/platform/homepage/icon-qingsu-desc.png')
      no-repeat center/100%;
  }
}
.desc-panel {
  .normal-text {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6c798c;
    line-height: 38px;
  }
  .bottom-tip {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9da3ac;
    line-height: 40px;
    margin-top: 50px;
  }
  .training-title {
    padding-bottom: 0 !important;
  }
}
</style>
